import { render, staticRenderFns } from "./EditableContactPersonList.vue?vue&type=template&id=5354da6c"
import script from "./EditableContactPersonList.vue?vue&type=script&lang=js"
export * from "./EditableContactPersonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports